import { getCurrentInstance } from "vue";

export function useRoot() {
  const instance = getCurrentInstance();

  return instance?.proxy;
}
